import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { LogoSmall } from 'Images';

interface ICustomMetaTitle {
  title: string;
  disablePrefix?: boolean;
}

export const CustomMetaTitle = ({ title, disablePrefix }: ICustomMetaTitle) => {
  const pageTitle = disablePrefix
    ? title
    : `${Dictionary[DICTIONARY.MedicationsAndPrescriptionsLobby].personalZone} - ${title}`;

  return (
    <>
      <title>{pageTitle}</title>
      <meta property='og:title' content={pageTitle} />
      <meta property='og:image' content={LogoSmall} />
    </>
  );
};
